(function () {
  if (window.__lpLoadingInit) return;
  window.__lpLoadingInit = true;

  function dedupeOverlays() {
    var overlays = document.querySelectorAll('.js-lp-loading');
    for (var i = 1; i < overlays.length; i++) {
      overlays[i].remove();
    }
  }

  function showLoading() {
    var el = document.querySelector('.js-lp-loading');
    if (el) el.style.display = 'flex';
  }

  dedupeOverlays();

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-lp-loading-btn')) showLoading();
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) window.location.reload();
  });
})();
